import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider, SAMLAuthProvider } from 'firebase/auth';
import { getAnalytics } from 'firebase/analytics';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGER_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID,
  measurementId: 'G-FS9813YRL7',
};

const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
export const samlAuthProvider = new SAMLAuthProvider('saml.caltrans');


export default app;
